var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { createPopper, } from "@popperjs/core";
import { Layer } from "react-atmosphere-layer";
import * as React from "react";
import useEventCallback from "./utils/useEventCallback";
export default function PopperLayer(_a) {
    var id = _a.id, reference = _a.reference, renderProp = _a.render, onOutsideMouseDown = _a.onOutsideMouseDown, optionsProp = _a.options, transitionExit = _a.transitionExit;
    var popperRef = React.useRef();
    var _b = React.useState(), popperState = _b[0], setPopperState = _b[1];
    var isMountedRef = React.useRef(true);
    var options = React.useMemo(function () {
        var _a;
        return (__assign(__assign({}, optionsProp), { modifiers: __spreadArrays(((_a = optionsProp === null || optionsProp === void 0 ? void 0 : optionsProp.modifiers) !== null && _a !== void 0 ? _a : []), [
                {
                    name: "popperLayer",
                    enabled: true,
                    phase: "afterWrite",
                    fn: function (_a) {
                        var state = _a.state;
                        if (isMountedRef.current) {
                            setPopperState(state);
                        }
                    },
                    requires: ["computeStyles"],
                },
            ]) }));
    }, [optionsProp]);
    var layerDivRef = React.useRef();
    var layerRef = function (layerDiv) {
        layerDivRef.current = layerDiv;
        if (layerDiv !== null) {
            if (!popperRef.current) {
                popperRef.current = createPopper(reference.current, layerDiv, options);
            }
        }
    };
    var onMouseDown = useEventCallback(function (e) {
        if (!onOutsideMouseDown) {
            return;
        }
        var target = e.target;
        if (target instanceof Node) {
            if (reference.current instanceof Element &&
                reference.current.contains(target)) {
                return;
            }
            if (layerDivRef.current instanceof Element &&
                layerDivRef.current.contains(target))
                return;
        }
        onOutsideMouseDown(e);
    });
    React.useEffect(function () {
        if (popperRef.current && options) {
            popperRef.current.setOptions(options);
        }
    }, [options]);
    React.useEffect(function () {
        document.addEventListener("mousedown", onMouseDown);
        return function () {
            isMountedRef.current = false;
            if (transitionExit !== true && popperRef.current) {
                popperRef.current.destroy();
                popperRef.current = undefined;
            }
            document.removeEventListener("mousedown", onMouseDown);
        };
    }, []);
    var render = React.useCallback(function (renderProps) { return (React.createElement("div", { id: id, ref: layerRef }, renderProp(__assign(__assign({}, renderProps), { completeTransitionExit: function () {
            renderProps.completeTransitionExit();
            if (popperRef.current !== undefined) {
                popperRef.current.destroy();
                popperRef.current = undefined;
            }
        }, popperState: popperState })))); }, [id, renderProp, popperState]);
    return React.createElement(Layer, { render: render, transitionExit: transitionExit });
}
